
/**
 * Created by Yu Zhang on 8/11/17.
 * Description:
 *
 * ------ maintenance history ------
 * 05/18/2022 Marcus Zhao added usage for  new EntryType.
 * 05/21/2022 Marcus Zhao added defaultEntryTypeName for support show entry type no-exsit in entry type list.
 */
import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of as observableOf, Observable, forkJoin } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';

import { AppConfig } from '@tamalelibs/models/app-config.model';
import {
    GET_ENTRY_TYPE, GET_ENTRY_TYPE_FAILURE, GET_ENTRY_TYPE_SUCCESS,
    GET_ENTRY_TEMPLATE_CONFIGUARTION, GET_ENTRY_TEMPLATE_CONFIGUARTION_SUCCESS, GET_ENTRY_TEMPLATE_CONFIGUARTION_FAILURE,
    CREATE_RELATIONSHIP, CREATE_RELATIONSHIP_SUCCESS, CREATE_RELATIONSHIP_FAILURE,
    CREATE_RELATIONSHIPS,
    GET_PRIVACY_CONFIGUARTION, GET_PRIVACY_CONFIGUARTION_SUCCESS, GET_PRIVACY_CONFIGUARTION_FAILURE,
    GET_PRIVACY_TEAMS, GET_PRIVACY_TEAMS_SUCCESS, GET_PRIVACY_TEAMS_FAILURE,
    UPDATE_PARENTNOTE_ENTITIES, UPDATE_PARENTNOTE_ENTITIES_SUCCESS, UPDATE_PARENTNOTE_ENTITIES_FAILURE,
    GET_THREAD_ATTACHMENT, GET_THREAD_ATTACHMENT_SUCCESS, GET_THREAD_ATTACHMENT_FAILURE, GET_ENTITY_TEMPLATE_CONFIGUARTION, GET_ENTITY_TEMPLATE_CONFIGUARTION_SUCCESS, GET_ENTITY_TEMPLATE_CONFIGUARTION_FAILURE, AddOneEntryTemplateConfiguration, AddOneEntityTemplateConfiguration,
} from '@tamalelibs/redux/template.actions';
import { EntryService } from '@tamalelibs/services/entry.service';
import { EntryTypeService } from '@tamalelibs/services/entry-type.service';
import { RelationshipService } from '@tamalelibs/services/relationship.service';
import { ConfigurationDataService } from '@tamalelibs/services/configuration-data.service';
import { EntryType } from '@tamalelibs/models/entry-type.model';
import { DefaultEntryTemplateConfiguration } from '@tamalelibs/constants/configuration.constants';
import { DefaultEntityTemplateConfiguration } from '@tamalelibs/constants/configurationEntity.constants';
import { LoggerService } from '@tamalelibs/services/logger.service';
import { NoteEntry } from '@tamalelibs/models/note-entry.model';
import { ThreadService } from '@tamalelibs/services/thread.service';
import { smartEffect } from '..';
import { StoreQuerierService } from '../../services/store-querier.service';
import { entityTemplatesSelector, entryTemplatesSelector } from '@tamalelibs/redux/template.reducer';
import * as _lodash from 'lodash';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';

@Injectable()
export class EntryTemplateWebEffects {
    constructor(
        private _actions$: Actions,
        private _entryService: EntryService,
        private _entryTypeService: EntryTypeService,
        private _threadService: ThreadService,
        private _configuratioDataService: ConfigurationDataService,
        private _relationshipService: RelationshipService,
        private _logger: LoggerService,
        private _store: Store<any>,
        private _storeQuerier: StoreQuerierService,
    ) { }

    getEntryTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_ENTRY_TYPE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => {
            let entry$, defaultEntryType$;
            const noteTypes: Array<EntryType> = new Array<EntryType>();
            const entryTypes$ = this._entryTypeService.getAllEntryTypes().pipe(
                map(res => res['entry-type-list'])
            );
            const observableArray = [entryTypes$];
            if (payload.entryId && payload.entryId.length > 0) {
                entry$ = this._entryService.getEntryById(payload.entryId);
            } else {
                entry$ = observableOf(new NoteEntry());
            }
            observableArray.push(entry$);
            defaultEntryType$ = this._entryTypeService.getDefaultEntryType(payload.entryclass);
            observableArray.push(defaultEntryType$);
            return forkJoin(observableArray).pipe(
                map(result => {
                    let entry, defaultEntryTypeId;
                    let defaultEntryTypeName = '';
                    const entryTypeList = result[0];
                    if (payload.entryId && payload.entryId.length > 0) {
                        entry = this._entryService.mapEntryValue(result[1]);
                        entry['attachments'] = this._threadService.mapThreadAttachment(result[1]);
                    }
                    for (const entryType of entryTypeList) {
                        const newEntryType = new EntryType(entryType.id, entryType.name, entryType.useNER, entryType.href, entryType.usage);
                        noteTypes.push(newEntryType);

                    }
                    // set entryType id and name for edit note
                    // added entry type name for handle not include this id in entry type list.
                    if (entry) {
                        defaultEntryTypeId = entry.entryTypeID;
                        defaultEntryTypeName = entry.entryTypeName;
                    }
                    // if entry type id is no-exist .use default entry type id
                    if (defaultEntryTypeId == null) {
                        defaultEntryTypeId = result[2].id.toString();
                    }
                    if (!entry) {
                        entry = new NoteEntry();
                    }

                    return {
                        type: GET_ENTRY_TYPE_SUCCESS,
                        payload: {
                            entryTypes: noteTypes,
                            defaultEntryTypeId: defaultEntryTypeId,
                            defaultEntryTypeName: defaultEntryTypeName,
                            entry: entry
                        }
                    };
                }),
                catchError(err => {
                    return observableOf({ type: GET_ENTRY_TYPE_FAILURE });
                })
            );
        })));

    getEntryConfigurationEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_ENTRY_TEMPLATE_CONFIGUARTION),
        map(action => action as any),
        map(action => action.payload),
        switchMap(payload => {
            const templates: Map<string, any> = this._storeQuerier.queryBySelector(entryTemplatesSelector);
            if (templates.has(payload)) {
                const observable = new Observable(subscriber => {
                    subscriber.next(undefined);
                    subscriber.complete();
                });
                return observable.pipe(
                    switchMap(item => {
                        return observableOf({
                            type: GET_ENTRY_TEMPLATE_CONFIGUARTION_SUCCESS,
                            payload: _lodash.cloneDeep(templates.get(payload)),
                        });
                    }),
                );
            } else {
                return this._configuratioDataService.getConfigurationById(payload).pipe(
                    map(res => {
                        const result = res ? res : JSON.parse(DefaultEntryTemplateConfiguration);
                        this._store.dispatch(new AddOneEntryTemplateConfiguration({
                            id: payload,
                            template: _lodash.cloneDeep(result),
                        }));
                        return {
                            type: GET_ENTRY_TEMPLATE_CONFIGUARTION_SUCCESS,
                            payload: result,
                        };
                    }),
                    catchError(err => {
                        if (err.toString().toLowerCase().indexOf('json parse error') > -1) {
                            this._logger.log('JSON Parse Error. This is a default entry template. Will use default entry template configuration.');
                            const result = JSON.parse(DefaultEntryTemplateConfiguration);
                            this._store.dispatch(new AddOneEntryTemplateConfiguration({
                                id: payload,
                                template: _lodash.cloneDeep(result),
                            }));
                            return observableOf({
                                type: GET_ENTRY_TEMPLATE_CONFIGUARTION_SUCCESS,
                                payload: result,
                            });
                        } else {
                            return observableOf({
                                type: GET_ENTRY_TEMPLATE_CONFIGUARTION_FAILURE,
                                payload: err.message ? err.message : err.toString()
                            });
                        }
                    }),
                );
            }
        }),
    ));

    createRelationshipsEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_RELATIONSHIPS),
        map(action => action as any),
        map(action => action.payload),
        switchMap(payload => this._relationshipService.createRelationships(payload).pipe(
            map(res => {
                return {
                    type: CREATE_RELATIONSHIP_SUCCESS,
                    payload: CREATE_RELATIONSHIP_SUCCESS
                };
            }),
            catchError(err => {
                return observableOf({
                    type: CREATE_RELATIONSHIP_FAILURE,
                    payload: err.message ? err.message.toString() : err.toString()
                });
            }))
        )));

    createRelationshipEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_RELATIONSHIP),
        map(action => action as any),
        map(action => action.payload),
        switchMap(payload => this._relationshipService.createRelationship(payload).pipe(
            map(res => {
                return {
                    type: CREATE_RELATIONSHIP_SUCCESS,
                    payload: CREATE_RELATIONSHIP_SUCCESS
                };
            }),
            catchError(err => {
                return observableOf({
                    type: CREATE_RELATIONSHIP_FAILURE,
                    payload: err.message ? err.message.toString() : err.toString()
                });
            }))
        )));

    updateThreadEntittiesEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(UPDATE_PARENTNOTE_ENTITIES),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._entryService.updateEntryEntities(payload.parentNoteId, payload.entityIds).pipe(
            map(res => {
                return ({
                    type: UPDATE_PARENTNOTE_ENTITIES_SUCCESS,
                    payload: UPDATE_PARENTNOTE_ENTITIES_SUCCESS
                });
            }),
            catchError(err => {
                return observableOf({ type: UPDATE_PARENTNOTE_ENTITIES_FAILURE, payload: err.message });
            }))
        )));

    getPrivacyConfigurationEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_PRIVACY_CONFIGUARTION),
        map(action => action as any),
        map(action => action.payload),
        switchMap(payload => this._configuratioDataService.getConfigurationByName(payload).pipe(
            map(res => {
                return {
                    type: GET_PRIVACY_CONFIGUARTION_SUCCESS,
                    payload: res
                };
            }),
            catchError(err => {
                return observableOf({
                    type: GET_PRIVACY_CONFIGUARTION_FAILURE,
                    payload: err.message ? err.message.toString() : err.toString()
                });
            }))
        )));

    getThreadAttachmentEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_THREAD_ATTACHMENT),
        map(action => action as any),
        map(action => action.payload),
        switchMap(payload => this._threadService.getThreadAttachmentsById(payload).pipe(
            map(response => {
                const thread = this._threadService.mapThreadAttachment(response);
                return {
                    type: GET_THREAD_ATTACHMENT_SUCCESS,
                    payload: thread
                };
            }),
            catchError(err => {
                return observableOf({
                    type: GET_THREAD_ATTACHMENT_FAILURE,
                    payload: err.message ? err.message.toString() : err.toString()
                });
            }))
        )));

    getPrivacyTeamsEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_PRIVACY_TEAMS),
        map(action => action as any),
        map(action => action.payload),
        switchMap(payload => this._entryService.getPrivacyData(payload, AppConfig.userId).pipe(
            map(res => {
                const configData = payload;
                let privacyTeams = [];
                const dataSource = [];
                let privacyTeamId = '';
                let privacyItem = {};
                if (configData.relationshipBasedDefaultingEnable) {
                    const primaryTeamRelId = configData.primaryTeamRelationshipTypeID;
                    const personalTeamRelId = configData.personTeamRelationshipTypeID;
                    const personalTeams = [];
                    const primaryTeams = [];
                    const allTeams = [];
                    const indicator = {};
                    const teams = res['relationship-list'];
                    for (let index = 0; index < teams.length; ++index) {
                        if (teams[index]['parent-entity']['data']['entity-type']['link']['phid'] === 'Team') {
                            const teamid = teams[index]['parent-entity']['data']['id'];
                            if (!indicator[teamid]) {
                                indicator[teamid] = true;
                                allTeams.push({
                                    id: teams[index]['parent-entity']['data']['id'],
                                    name: teams[index]['parent-entity']['data']['short-name']
                                });
                            }
                            if (primaryTeamRelId && primaryTeamRelId === teams[index]['relationship-type']['data']['id']) {
                                primaryTeams.push({
                                    id: teams[index]['parent-entity']['data']['id'],
                                    name: teams[index]['parent-entity']['data']['short-name']
                                });
                            }
                            if (personalTeamRelId && personalTeamRelId === teams[index]['relationship-type']['data']['id']) {
                                personalTeams.push({
                                    id: teams[index]['parent-entity']['data']['id'],
                                    name: teams[index]['parent-entity']['data']['short-name']
                                });
                            }
                        }
                    }

                    ArrayHelperService.sort(allTeams, 'name');
                    ArrayHelperService.sort(primaryTeams, 'name');
                    ArrayHelperService.sort(personalTeams, 'name');

                    dataSource.push({
                        id: '000000',
                        'name': 'Public'
                    });
                    for (let i = 0; i < allTeams.length; i++) {
                        dataSource.push({
                            id: allTeams[i].id,
                            name: allTeams[i]['name']
                        });
                    }

                    privacyTeams = dataSource;

                    if (configData.privacySetting === 'primary team') {
                        privacyTeamId = primaryTeams[0] ? primaryTeams[0].id : privacyTeams[0].id;
                        privacyItem = primaryTeams[0] ? primaryTeams[0] : privacyTeams[0];
                    } else if (configData.privacySetting === 'personal team') {
                        privacyTeamId = personalTeams[0] ? personalTeams[0].id : privacyTeams[0].id;
                        privacyItem = personalTeams[0] ? personalTeams[0] : privacyTeams[0];
                    } else {
                        privacyTeamId = privacyTeams[0].id;
                        privacyItem = privacyTeams[0];
                    }
                } else { // list all accessible teams
                    const teams = res['team-list'];
                    ArrayHelperService.sort(teams, 'short-name');

                    dataSource.push({
                        id: '000000',
                        'name': 'Public'
                    });
                    for (let i = 0; i < teams.length; i++) {
                        dataSource.push({
                            id: teams[i].id,
                            name: teams[i]['short-name']
                        });
                    }

                    privacyTeams = dataSource;
                    privacyTeamId = dataSource[0].id;
                    privacyItem = dataSource[0];
                }

                return {
                    type: GET_PRIVACY_TEAMS_SUCCESS,
                    payload:
                    {
                        privacyTeamId: privacyTeamId,
                        privacySelectedTeam: privacyItem,
                        privacyTeams: privacyTeams
                    }
                };
            }),
            catchError(err => {
                return observableOf({
                    type: GET_PRIVACY_CONFIGUARTION_FAILURE,
                    payload: err.message ? err.message.toString() : err.toString()
                });
            }))
        )));

    getEntityConfigurationEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_ENTITY_TEMPLATE_CONFIGUARTION),
        map(action => action as any),
        // map(action => action.payload),
        switchMap(action => {
            const templates: Map<string, any> = this._storeQuerier.queryBySelector(entityTemplatesSelector);
            if (templates.has(action.payload)) {
                const observable = new Observable(subscriber => {
                    subscriber.next(undefined);
                    subscriber.complete();
                });
                return observable.pipe(
                    switchMap(item => {
                        return observableOf(smartEffect(action, {
                            type: GET_ENTITY_TEMPLATE_CONFIGUARTION_SUCCESS,
                            payload: _lodash.cloneDeep(templates.get(action.payload)),
                        }));
                    }),
                );
            } else {
                return this._configuratioDataService.getConfigurationById(action.payload).pipe(
                    map(res => {
                        const result = res ? res : DefaultEntityTemplateConfiguration;
                        this._store.dispatch(new AddOneEntityTemplateConfiguration({
                            id: action.payload,
                            template: _lodash.cloneDeep(result),
                        }));
                        return smartEffect(action, {
                            type: GET_ENTITY_TEMPLATE_CONFIGUARTION_SUCCESS,
                            payload: result,
                        });

                        // return {
                        //     type: GET_ENTITY_TEMPLATE_CONFIGUARTION_SUCCESS,
                        //     payload: res ? res : DefaultEntityTemplateConfiguration
                        // }
                    }),
                    catchError(err => {
                        if (err.toString().toLowerCase().indexOf('json parse error') > -1) {
                            this._logger.log('JSON Parse Error. This is a default entry template. Will use default entry template configuration.');
                            const result = DefaultEntityTemplateConfiguration;
                            this._store.dispatch(new AddOneEntityTemplateConfiguration({
                                id: action.payload,
                                template: _lodash.cloneDeep(result),
                            }));
                            return observableOf({
                                type: GET_ENTITY_TEMPLATE_CONFIGUARTION_SUCCESS,
                                payload: result,
                            });
                        } else {
                            return observableOf({
                                type: GET_ENTITY_TEMPLATE_CONFIGUARTION_FAILURE,
                                payload: err.message ? err.message : err.toString()
                            });
                        }
                    }),
                );
            }
        }
        ),
    ));

}
